import { Star } from '@components/icons/Star'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useConsultation } from '@/hooks/useConsultation'
import { useConsultationStep } from '@/hooks/useConsultationStep'
import { getSlugTranslation } from '@/locale/utils'
import { CONSULTATION_STEPS } from '@/types/consultation'

interface RatingProps {
  onConfirmRating: (rating: number) => void
}

export const Rating = ({ onConfirmRating }: RatingProps) => {
  const { t } = useTranslation()
  const [selectedRating, setSelectedRating] = useState<number | null>(null)
  const { updateStep } = useConsultationStep()
  const { canDoFollowUp } = useConsultation()

  const handleFollowUp = () => {
    updateStep(CONSULTATION_STEPS.LANDING)
  }

  return (
    <div className="flex w-full animate-fade-in flex-col gap-6 rounded-2xl bg-white p-5 drop-shadow-chat-bubble" data-testid="rating-container">
      <p className="text-center font-bold">{getSlugTranslation('rating.description')}</p>

      <div className="flex flex-row flex-wrap justify-between gap-2 px-4" data-testid="rating-stars">
        {Array.from({ length: 5 }).map((_, index) => {
          const selected = Boolean(selectedRating && index < selectedRating)
          return (
            <button
              key={index}
              onClick={() => {
                setSelectedRating(index + 1)
              }}
              data-testid={`rating-${index + 1}`}
            >
              <Star selected={selected} />
            </button>
          )
        })}
      </div>

      <div className={`mx-4 flex items-center border-t border-t-gray pt-3 ${!canDoFollowUp && selectedRating === null ? 'hidden' : ''}`}>
        {selectedRating && selectedRating > 0 ? (
          <div className="flex w-full animate-fade-in items-center justify-between">
            <button
              className="w-1/2 p-2 text-sm font-bold uppercase text-gray-text opacity-75"
              onClick={() => {
                setSelectedRating(null)
              }}
              data-testid="rating-cancel"
            >
              {t('button.cancel')}
            </button>

            <span className="h-8 border-r border-r-gray" />

            <button
              className="w-1/2 p-2 text-sm font-bold uppercase text-primary"
              onClick={() => onConfirmRating(selectedRating)}
              data-testid="rating-confirm"
            >
              {t('button.confirm')}
            </button>
          </div>
        ) : canDoFollowUp ? (
          <button className="w-full animate-fade-in p-2 text-sm font-bold text-primary" onClick={handleFollowUp} data-testid="rating-follow-up">
            {t('follow_up')}
          </button>
        ) : null}
      </div>
    </div>
  )
}
